var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewAngleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33 0.316V1.926L4.124 5.314L0.904 1.926V0.316L4.124 3.704L7.33 0.316Z",
    fill: "#703CE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAngleDown);
export default __webpack_public_path__ + "static/media/new-angle-down.f0d2c407c6bf5fcc76c280cdc7f183e1.svg";
export { ForwardRef as ReactComponent };